<template>
  <b-card>
    <h3>Visualizar Usuário</h3>
    <b-row>
      <b-col cols="6">
        <b-form-group label="Nome Completo:">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="icon-user"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model.trim="usuario.nome" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="CPF:">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="icon-user"></i></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-mask="'###.###.###-##'" v-model="usuario.cpf" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group label="E-mail:">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>@</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model.trim="usuario.email" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Confirme o e-mail:">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>@</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model.trim="usuario.email" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group label="Celular:">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text><i class="fa fa-phone"/></b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model.trim="usuario.celular" v-mask="'(##)#####-####'" disabled/>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Status:">
          <b-form-radio-group v-model="usuario.status" :options="status" disabled/>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <b-button @click="navigate('/usuarios')">
          <i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Voltar
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  data () {
    return {
      usuario: {
        nome: null,
        cpf: null,
        email: null,
        celular: null,
        status: null
      },
      status: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ]
    }
  },
  mounted () {
    this.carreggar(this.$route.params.id)
  },
  methods: {
    carreggar (id) {
      Vue.http.get('api/usuario/' + id).then(response => {
        let data = response.body.data

        if (data.length > 0) {
          this.usuario = {
            nome: data[0].nome,
            cpf: data[0].cpf,
            email: data[0].email,
            celular: data[0].celular,
            status: data[0].ativo
          }
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioVisualizar.vue